import React from 'react';
import { Input } from 'antd';
import { Button } from '~/ui/components';
import { WhatsApp } from '~/ui/assets/icons';
import WhatsappPreview from '../components/WhatsappPreview';
import { WHATSAPP_COMMENT_MAX_LENGTH } from '../constants';
import {
  StepBody,
  HeaderCard,
  HeaderLeft,
  WhatsAppIconChip,
  HeaderInfo,
  HeaderTitle,
  HeaderSubtitle,
  SectionTitle,
  FieldGroup,
  CharCounter,
  PreviewLabel,
  WhatsappBubble,
  Footer,
  FooterHint,
} from '../RaFlow.styles';

type WhatsAppStepProps = {
  ticketId: string;
  clientName: string;
  normalizedStatusName: string;
  hasFiles: boolean;
  agentComment: string;
  onCommentChange: (comment: string) => void;
  onNext: () => void;
  nextHint?: string;
};

function WhatsAppStep({
  ticketId,
  clientName,
  normalizedStatusName,
  hasFiles,
  agentComment,
  onCommentChange,
  onNext,
  nextHint = 'Próximo: resposta pública no Reclame Aqui.',
}: WhatsAppStepProps) {
  const isAtLimit = agentComment.length >= WHATSAPP_COMMENT_MAX_LENGTH;

  return (
    <StepBody>
      <HeaderCard accent="whatsapp">
        <HeaderLeft>
          <WhatsAppIconChip>
            <WhatsApp />
          </WhatsAppIconChip>
          <HeaderInfo>
            <HeaderTitle accent="whatsapp">Resposta no WhatsApp</HeaderTitle>
            <HeaderSubtitle>Mensagem direta e privada ao cliente</HeaderSubtitle>
          </HeaderInfo>
        </HeaderLeft>
      </HeaderCard>

      <FieldGroup>
        <SectionTitle>Comentário do agente</SectionTitle>
        <Input.TextArea
          value={agentComment}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder="Digite aqui o comentário que será inserido na mensagem ao cliente"
          autoSize={{ minRows: 3, maxRows: 6 }}
          maxLength={WHATSAPP_COMMENT_MAX_LENGTH}
          data-testid="whatsapp-comment-input"
        />
        <CharCounter error={isAtLimit}>
          {agentComment.length} / {WHATSAPP_COMMENT_MAX_LENGTH}
        </CharCounter>
      </FieldGroup>

      <FieldGroup>
        <PreviewLabel>Pré-visualização da mensagem</PreviewLabel>
        <WhatsappBubble data-testid="whatsapp-preview">
          <WhatsappPreview
            clientName={clientName}
            ticketId={ticketId}
            agentComment={agentComment}
            normalizedStatusName={normalizedStatusName}
            hasFiles={hasFiles}
          />
        </WhatsappBubble>
      </FieldGroup>

      <Footer>
        <FooterHint>{nextHint}</FooterHint>
        <Button
          rounded
          onClick={onNext}
          type="button"
          disabled={!agentComment.trim()}
          data-testid="whatsapp-next-button"
        >
          Avançar
        </Button>
      </Footer>
    </StepBody>
  );
}

export default WhatsAppStep;
